import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconTools from '@/icons/Tools.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const PendingProcessingNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'pending_processing'>;
}) => {
  const { t } = useLingui();

  const requestReference = notification.request.reference;
  const workshopName = notification.data.onBehalfOfWorkshop.name;

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.pending-processing.label',
        message: `Request for service updated for request ${requestReference}`,
      })}
      icon={<IconTools />}
      type="new"
      notification={notification}
      notificationHeader={(color) => (
        <Trans id="notification.pending-processing">
          <InlineText weight="medium" color={color}>
            You
          </InlineText>{' '}
          may notify the workshop{' '}
          <InlineText weight="medium" color={color}>
            {workshopName}
          </InlineText>{' '}
          that the service can begin.
        </Trans>
      )}
    />
  );
};
